(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutPickupPointController', function ($scope, $element, ControlService) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'PickupPoint';

            $scope.registerControl(controlName, $element.get(0));

            $scope.init = function (jwtKey, lang, allowedCountries, country, mapCenter) {
                var allowedCountriesArray = null;
                var mapCenterArray = null;

                try {
                    allowedCountriesArray = allowedCountries.split(",").map(e => e.trim());
                } catch (error) {
                    console.error('Failed to parse comma-separated allowed countries for PickupPoint widget');
                }

                try {
                    mapCenterArray = mapCenter.split(",").map(e => e.trim()).map(e => parseFloat(e));
                } catch (error) {
                    console.error('Failed to parse comma-separated mapCenter parameter for PickupPoint widget');
                }

                window.PostisWidget && window.PostisWidget.init({
                    attached: false,
                    onSelect: saveWidgetPickupPoints,
                    key: jwtKey,
                    lang: lang,
                    options: {
                        map: {
                            mapCenter: mapCenterArray
                        },
                        pickup: {
                            allowedCountries: allowedCountriesArray,
                        },
                        client: {
                            country: country
                        }
                    },
                });
            }
            
            registerControlUpdateAfterOrderReload();
            registerOpenPickupPointModalHandler();
            registerControlExternalReset();

            function registerOpenPickupPointModalHandler() {
                $scope.Control.openPickupPoints = function () {
                    window.PostisWidget && window.PostisWidget.open("pickup");
                };
            }
            
            function registerControlExternalReset() {
                $scope.$watch("PickupPoint.Current",
                    function (newValue, prevValue) {
                        if (prevValue && !newValue) {
                            reloadControlModel(newValue);
                        }
                    });
            }

            function registerControlUpdateAfterOrderReload() {
                $scope.$watch("Order.Current.PickupPoint",
                    function (newValue, prevValue) {
                        if (!prevValue && !newValue) {
                            return;
                        }

                        $scope.setControlValue(controlName, newValue);

                        reloadControlModel(newValue);
                    });
            }

            function reloadControlModel(model) {
                if (!model) {
                    $scope.Control.pickUpDetails = null;

                    return;
                }

                var data = JSON.parse(model.Data);
                var location = data.location;

                $scope.Control.pickUpDetails = {
                    name: location.name,
                    locality: location.locality,
                    address: location.address
                };
            }

            function saveWidgetPickupPoints(pickupPointData) {
                var model = {
                    CompanyCode: "POSTIS",
                    Data: JSON.stringify(pickupPointData),
                    LocationId: pickupPointData.location.id,
                    CourierId: pickupPointData.location.courierId,
                };

                ControlService.invokeCheckout($scope, $element, 'SetPickupPoint', model).then(
                    function (response) {
                        $scope.setControlValue(controlName, model);

                        reloadControlModel(model);

                        $scope.setControlValue("Store", null);

                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                    }
                );
            };
        });
})();